
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import * as HTTPManager from './HTTPManager';
import { ACT } from "./recoil";
import { useSetRecoilState } from "recoil";

function PageLogin() {
  const navigate = useNavigate();
  const [requestCode, setRequestCode] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [authCode, setAuthCode] = useState("");
  const setACT = useSetRecoilState(ACT);

  useEffect(() => {
    setACT("");
  }, []);

  async function requestAuthCode() {
    let response = await HTTPManager.RequestAuthCode({
      phoneNumber: phoneNumber,
    });

    if (response.code !== undefined && response.code !== null) {
      if (response.code === 200) {
        setRequestCode(true);
      } else if (response.code === 4041) {
        alert('인증요청 횟수 초과 잠시 후 시도해 주세요.');
      }
    }
  }

  async function validateAuthCode() {
    let response = await HTTPManager.ValidateAuthCode({
      phoneNumber: phoneNumber,
      authCode: authCode,
    });

    if (response?.code === 200) {
      setACT(response.accessToken);
      setRequestCode(false);
      setAuthCode("");
      navigate("/reservation", { replace: false });
    }
  }


  return (
    <div className="flex flex-col w-full h-screen items-center justify-center mt-[-21.75px]">

      <div className="flex flex-col mb-5 items-center">
        <div className="font-bold text-[30px]">코리아트래블스토어</div>
        <div className="font-bold text-[30px]">호텔 예약 정보</div>
      </div>
      <div className="flex flex-col gap-0">
        <div className="flex flex-row gap-0 items-center" style={{

        }}>
          <label className="relative select-none text-[14px] flex-row gap-1 items-center justify-center checkBoxIdSearch border pl-[45px] h-[45px]">
            <img src="./cell_phone_dim.png" className="absolute left-3 w-[25px]" />
            <input id={`checkBoxIdSearch`}
              placeholder="휴대전화번호"
              className="cursor-pointer focus:outline-none p-[10px] mr-1" type="tel" maxLength="16" onChange={(e) => {
                setPhoneNumber(e.target.value);
              }}
              value={phoneNumber}
              autoComplete="off"
            />
          </label>
          <div className="flex bg-[black] text-[white] px-[10px] text-[14px] h-[45px] items-center justify-center cursor-pointer w-[80px] focus:outline-none" tabIndex={0}
            onClick={async () => {
              await requestAuthCode();
            }}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await requestAuthCode();
              }
            }}
          >
            인증요청
          </div>
        </div>
        {
          <div className="flex flex-row gap-0 items-center" style={{
            visibility: requestCode ? "visible" : "hidden",
          }}>
            <label className="relative select-none text-[14px] flex-row gap-1 items-center justify-center checkBoxIdSearch border-x border-b pl-[45px] h-[45px]">
              <input id={`checkBoxIdSearch`}
                placeholder="인증번호"
                className="cursor-pointer focus:outline-none p-[10px] mr-1" autoComplete="off" type="tel" maxLength="16"
                value={authCode}
                onChange={(e) => {
                  setAuthCode(e.target.value);
                }} />
            </label>
            <div className="flex bg-[black] text-[white] px-[10px] text-[14px] h-[45px] items-center justify-center cursor-pointer w-[80px]"
              onClick={() => {

              }}>
              <div className="flex bg-[black] text-[white] px-[10px] text-[14px] h-[45px] items-center justify-center cursor-pointer w-[80px] focus:outline-none" tabIndex={0}
                onClick={() => {
                  validateAuthCode();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    validateAuthCode();
                  }
                }}
              >
                확인
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

export default PageLogin;
